// src/mocks/handlers/auth/passwordChangeHandler.ts
import { rest } from 'msw';
import { API_ENDPOINTS } from '@/services/api/endpoints';
import { VITE_MSW_BASE_URL } from '@/config';
import { ChangePasswordRequestBody } from '@/domains/auth/auth.types';
import { genericResponse } from '@/shared/types/api';

export const passwordChangeHandler = rest.post<
  ChangePasswordRequestBody,
  genericResponse
>(
  `${VITE_MSW_BASE_URL}${API_ENDPOINTS.AUTH_CHANGE_PASSWORD}`,
  (req, res, ctx) => {
    const token = req.headers.get('Authorization');
    if (!token) {
      return res(ctx.status(500), ctx.json({ detail: 'Something went wrong' }));
    }

    return res(
      ctx.status(200),
      ctx.json({ message: 'Password has been changed successfully' }),
    );
  },
);
